const IdentityManage = () => import("@/vuepage/authority-manage/IdentityManage");
const AdministratorList = () => import("@/vuepage/authority-manage/AdministratorList");
const MenuManage = () => import("@/vuepage/authority-manage/MenuManage");
const AddAdmin = () => import("@/vuepage/authority-manage/AddAdmin");
const EditAdmin = () => import("@/vuepage/authority-manage/EditAdmin");
export default [
  {
    path: "/admin-list",
    component: AdministratorList,
    meta: [
      {
        name: "权限管理",
      },
      {
        name: "管理员管理",
        activeRoute: "/admin-list",
      },
    ],
  },
  {
    path: "/add-admin",
    component: AddAdmin,
    meta: [
      {
        name: "权限管理",
      },
      {
        name: "新建管理员",
        activeRoute: "/admin-list",
      },
    ],
  },
  {
    path: "/edit-admin",
    component: EditAdmin,
    meta: [
      {
        name: "权限管理",
      },
      {
        name: "编辑管理员",
        activeRoute: "/admin-list",
      },
    ],
  },
  {
    path: "/role-list",
    component: IdentityManage,
    meta: [
      {
        name: "权限管理",
      },
      {
        name: "角色管理",
        activeRoute: "/role-list",
      },
    ],
  },
  {
    path: "/menu-list",
    component: MenuManage,
    meta: [
      {
        name: "权限管理",
      },
      {
        name: "菜单管理",
        activeRoute: "/menu-list",
      },
    ],
  },
];
